module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/sushi-fe859429852db50e3097ad8659f4910d.svg";